import { For, type JSX } from 'solid-js';
import { t } from '../i18n';
import { MAP_MODES, type MapMode } from '../lib/fleet-map';

// The Machines Map's "Show" switch (#6562, prototype `mapBy`): Health, CPU, Memory, Disk,
// as pressed buttons in the view switch's own frame (`.fleet-view-switch`). It sits where
// the sort note does in the other two views. Presenter: the list owns the mode.

const MODE_LABEL: Readonly<Record<MapMode, string>> = {
  health: 'fleet.machines.map_mode_health',
  cpu: 'fleet.machines.bar_cpu',
  memory: 'fleet.machines.bar_memory',
  disk: 'fleet.machines.bar_disk',
};

export function MapModeSwitch(props: {
  readonly mode: MapMode;
  readonly onMode: (mode: MapMode) => void;
}): JSX.Element {
  return (
    <div class="machine-map-mode">
      <span class="machine-map-mode__label" aria-hidden="true">
        {t('fleet.machines.map_show')}
      </span>
      <fieldset class="fleet-view-switch">
        <legend class="sr-only">{t('fleet.machines.map_show_aria')}</legend>
        <For each={MAP_MODES}>
          {(m) => (
            <button
              type="button"
              class="fleet-view-switch__btn"
              aria-pressed={props.mode === m}
              onClick={() => props.onMode(m)}
            >
              {t(MODE_LABEL[m])}
            </button>
          )}
        </For>
      </fieldset>
    </div>
  );
}
